import React from 'react';
import arrow from '../assets/images/icon/arrow_forward_ios.png';
import orangearrow from '../assets/images/icon/orange-down.png';
import dashboard from '../assets/images/icon/dashboard.png';
import employees from '../assets/images/icon/employees.png';
import contractor from '../assets/images/icon/contractor.png';
import benefits from '../assets/images/icon/benefits.png';
import deductions from '../assets/images/icon/deductions.png';
import reports from '../assets/images/icon/reports.png';
import payrollnootLogo from '../assets/images/payrollnoot-logo-lg.png';
import '../styles/main.scss'
import { NavLink } from "react-bootstrap";
import { useLocation, useNavigate } from 'react-router-dom';
import routes from 'constants/routes';
import { cn, stringMerger } from 'utils';
import useApp from 'hooks/useApp';
import useFeatures from 'hooks/useFeatures';
import useBranding from 'hooks/useBranding';
import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../axios/axiosInstance';

const menuItems = [
  {
    name: 'Dashboard',
    icon: dashboard,
    featureKey: 'dashboard',
    path: routes.DASHBOARD.HOME,
    otherPaths: [
      stringMerger(routes.DASHBOARD.HOME, routes.DASHBOARD.PAYROLL_TIME_KEEPING.HOME),
      stringMerger(routes.DASHBOARD.HOME, routes.DASHBOARD.PAYROLL_TIME_KEEPING.HOME, routes.DASHBOARD.PAYROLL_TIME_KEEPING.ADD_TIME_CARD),
      stringMerger(routes.DASHBOARD.HOME, routes.DASHBOARD.MANAGE_COMPANY),
      stringMerger(routes.DASHBOARD.HOME, routes.DASHBOARD.START_NEW_PAYROLL),
    ]
  },
  {
    name: 'Employees',
    icon: employees,
    featureKey: 'manage_employees',
    path: routes.EMPLOYEES.HOME,
    otherPaths: [
      stringMerger(routes.EMPLOYEES.HOME, routes.EMPLOYEES.ADD_EDIT_EMPLOYEE),
      stringMerger(routes.EMPLOYEES.HOME, routes.EMPLOYEES.VIEW)
    ]
  },
  {
    name: 'Contractor',
    icon: contractor,
    featureKey: 'manage_contractors',
    path: routes.CONTRACTOR.HOME,
    otherPaths: [
      stringMerger(routes.CONTRACTOR.HOME, routes.CONTRACTOR.VIEW),
      stringMerger(routes.CONTRACTOR.HOME, routes.CONTRACTOR.ADD_EDIT_CONTRACTOR),
    ]
  },
  {
    name: 'Benefits',
    icon: benefits,
    featureKey: 'benefits',
    path: routes.BENEFITS.HOME,
    otherPaths: [
      stringMerger(routes.BENEFITS.HOME, routes.BENEFITS.ADD_EDIT_COMPANY_BENEFIT),
      stringMerger(routes.BENEFITS.HOME, routes.BENEFITS.ADD_EDIT_EMPLOYEE_BENEFIT),
    ]
  },
  {
    name: 'Deductions',
    icon: deductions,
    featureKey: 'deductions',
    path: routes.DEDUCTIONS.HOME,
    otherPaths: [
      stringMerger(routes.DEDUCTIONS.HOME, routes.DEDUCTIONS.ADD_EDIT_MCN_DEDUCTION),
      stringMerger(routes.DEDUCTIONS.HOME, routes.DEDUCTIONS.ADD_EDIT_CHILD_SUPPORT_DEDUCTION),
    ]
  },
  {
    name: 'Time Off',
    icon: benefits,
    featureKey: 'time_off',
    path: routes.TIME_OFF.HOME,
    otherPaths: [],
  },
  {
    name: 'Reports',
    icon: reports,
    featureKey: 'reports',
    path: stringMerger(routes.REPORTS.HOME, routes.REPORTS.ALL_REPORTS),
    otherPaths: [
      stringMerger(routes.REPORTS.HOME),
      stringMerger(routes.REPORTS.HOME, routes.REPORTS.AUTHORIZATION_DOCS),
      stringMerger(routes.REPORTS.HOME, routes.REPORTS.COMPANY_TAX_DOCS),
      stringMerger(routes.REPORTS.HOME, routes.REPORTS.CONTRACTOR_TAX_DOCS),
      stringMerger(routes.REPORTS.HOME, routes.REPORTS.EMPLOYEE_TAX_DOCS),
      stringMerger(routes.REPORTS.HOME, routes.REPORTS.AUDIT_TRAIL),
    ]
  },
  {
    name: 'Locations',
    icon: employees,
    featureKey: 'location_management',
    path: '/dashboard/locations',
    otherPaths: [],
  },
  {
    name: 'Billing',
    icon: reports,
    featureKey: 'billing',
    path: '/dashboard/billing',
    otherPaths: [],
  },
  {
    name: 'Onboarding',
    icon: employees,
    featureKey: 'user_management',
    path: routes.ONBOARDING.HOME,
    otherPaths: [],
    showBadge: true,
  },
];

const Sidebar = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { isSidebarOpen } = useApp();
  const { hasFeature } = useFeatures();
  const branding = useBranding();

  const companyId = localStorage.getItem('companyId');
  const { data: pendingAccounts = [] } = useQuery({
    queryKey: ['pending-approvals', companyId],
    queryFn: async () => (await axiosInstance.get(`/auth/pending-approvals/${companyId}`)).data ?? [],
    enabled: !!companyId,
    refetchInterval: 30000,
  });

  const pendingCount = pendingAccounts.length;
  const visibleItems = menuItems.filter(item => hasFeature(item.featureKey));

  return (
    <div className={cn("sidebar", isSidebarOpen ? "open" : "closed")}>
      <div className="sidebar-logo-container">
        <img
          src={branding.logoUrl || payrollnootLogo}
          alt={branding.productName}
          className="sidebar-logo"
        />
      </div>
      <ul className="p-0">
        {visibleItems.map((item, index) => (
          <li
            key={index}
            className={`d-flex justify-content-between align-items-center ${(pathname === item?.path || item?.otherPaths?.includes(pathname)) ? 'active-item' : ''}`}
          >
            <NavLink
              onClick={() => navigate(item.path)}
              className="d-flex align-items-center gap-3"
            >
              <img src={item.icon} alt={item.name} />
              <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                {item.name}
                {item.showBadge && pendingCount > 0 && (
                  <span style={{ background: '#E7730A', color: '#fff', borderRadius: 20, fontSize: 11, fontWeight: 700, padding: '1px 7px', lineHeight: '18px', minWidth: 20, textAlign: 'center' }}>
                    {pendingCount}
                  </span>
                )}
              </span>
            </NavLink>
            <img src={item.active ? orangearrow : arrow} className="img-fluid arrow-images" alt="Arrow" />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Sidebar;
